module.exports = __webpack_public_path__ + "static/media/ELEMENTOS_ICONO3 SECCION2.08a938a8.png";